
import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { usePermissions } from "../../hooks/usePermissions";
import { SideBarData } from "./sideBarData"

export function SidebarNavigation(props) {
    const permissions = usePermissions();
    const [showSubMenu, setShowSubMenu] = useState(false);
    const subNav = () => {
        setShowSubMenu(!showSubMenu)
    }
    const location = useLocation()
    const activeSpanBar = <span className="slb-nav-link-bar"></span>
    const filteredData = SideBarData.filter(x=> (x.label || "").toLowerCase() === 'admin' ? permissions.FullControl : true)
    function renderNavItem (x){
        return <NavLink
        to={x.path}
        className={
            x.className
        }
    >
        <span>{x.icon}</span>
        {x.label}
        {activeSpanBar}
    </NavLink>
    }
    return <>
    
        <div className="slb-sidebar-menu">
           
            {filteredData.map((item, index) => {
                const sub =  item.subNav && item.subNav.find((x)=>x.path===location.pathname) ? true : false
                return <div className="slb-sidebar-menu-link" key={index}>
                    
                    {item.path ? renderNavItem(item)  : <span className={ sub ? "nav-link-bold nav-link" : "nav-link"}  onClick={subNav}><span>
                        
<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path id="admin-generic" d="M21 12.3558H18.3067C18.107 13.2006 17.769 14.0065 17.3065 14.741L19.2155 16.644L16.6214 19.2387L14.7124 17.3293C13.9829 17.7804 13.185 18.1103 12.3499 18.3061V21H8.64697V18.3061C7.81186 18.1103 7.014 17.7804 6.28441 17.3293L4.38491 19.2387L1.76719 16.6188L3.66984 14.7158C3.21883 13.986 2.88905 13.188 2.69332 12.3527H0V8.68672H2.67757C2.87499 7.83933 3.2085 7.02956 3.66512 6.28897L1.76719 4.3859L4.36128 1.79122L6.26236 3.6943C6.99773 3.2337 7.80312 2.89583 8.64697 2.69392V0H12.353V2.69392C13.1881 2.8897 13.986 3.21956 14.7156 3.67067L16.6182 1.76759L19.2375 4.38747L17.3254 6.28897C17.7821 7.02956 18.1156 7.83933 18.313 8.68672H20.9905L21 12.3558ZM10.5008 14.2101C11.2338 14.2101 11.9503 13.9926 12.5598 13.5853C13.1692 13.178 13.6442 12.5991 13.9247 11.9217C14.2053 11.2444 14.2786 10.499 14.1356 9.77997C13.9926 9.0609 13.6397 8.4004 13.1214 7.88198C12.6031 7.36356 11.9427 7.01051 11.2238 6.86748C10.5049 6.72444 9.75973 6.79785 9.08254 7.07842C8.40534 7.35899 7.82653 7.83411 7.41931 8.44371C7.01208 9.0533 6.79472 9.77 6.79472 10.5032C6.7941 10.9901 6.88953 11.4724 7.07556 11.9225C7.26159 12.3725 7.53455 12.7814 7.87882 13.1257C8.22308 13.4701 8.63188 13.7431 9.0818 13.9291C9.53172 14.1152 10.0139 14.2107 10.5008 14.2101Z" fill="white"/>
</svg>


</span>
Admin <span className="slb-nav-link-bar"></span></span>

}
<div className="slb-sidebar-sub-menu-link">{item.subNav && item.subNav.map(x => {
                        return renderNavItem(x)
                    })}
                    </div>
                </div>
            })}
        </div>
      
    </>
}